import { createFileRoute } from '@tanstack/react-router';
import { AuthLayout } from '../components/layouts/AuthLayout';
import { SelfRegisterForm } from '../components/auth/SelfRegisterForm';

// Ruta PÚBLICA (sin auth, fuera de _authenticated): UI de prueba del flujo de autoregistro.
export const Route = createFileRoute('/self-register')({
    component: SelfRegisterRoute,
});

function SelfRegisterRoute() {
    return (
        <AuthLayout>
            <SelfRegisterForm />
        </AuthLayout>
    );
}
